import { proxy } from 'valtio';

import { msCatalystApi } from '../api/ms-catalyst-api.js';

export const authState = proxy({
  isLoading: true,
  isAuth: false,
  isAdmin: false,
  user: null,
  logout: async () => {
    authState.isLoadig = true;

    await msCatalystApi.post('/auth/logout');

    authState.isLoadig = false;
    window.location.reload();
  },
  updateConsent: () => {
    authState.user.details.consentTermsOfParticipation = true;
  },
});
